/**
 * The slug of the last studio this browser opened.
 *
 * Runbook part 1 §1 asks for the org selector to have the last-used studio
 * preselected. The server deliberately does not tell us which that was — the
 * selector response carries nothing but slugs and names, so "last used" is a
 * per-browser convenience, not identity state. A slug on its own is not
 * sensitive (org NAMES are what part 1 §1 keeps behind authentication, and
 * those still only ever arrive in an authenticated response), so this survives
 * logout on purpose: a shared studio machine is exactly where re-picking the
 * same studio every morning is tedious.
 *
 * Lives outside the component module so Fast Refresh keeps working there
 * (`react-refresh/only-export-components`).
 */
const LAST_ORG_KEY = 'ps_last_org'

export function rememberLastOrg(slug: string | null | undefined): void {
  if (!slug) return
  try {
    localStorage.setItem(LAST_ORG_KEY, slug)
  } catch {
    // A private-browsing quota error must never break a login.
  }
}

export function readLastOrg(): string | null {
  try {
    return localStorage.getItem(LAST_ORG_KEY)
  } catch {
    return null
  }
}
